import React from 'react';
import { Loading } from '../../../../components';
import { useDidMount } from 'beautiful-react-hooks';
import { callLogoutSSO } from '../../../../redux/auth/auth.functions';

const ExternalLogoutRedirect = () => {
  useDidMount(() => {
    callLogoutSSO();
  });

  return <Loading loading />;
};

export default ExternalLogoutRedirect;
